// ## The MIXER for audio ##
import { trace } from 'rytm-helpers'
import { 
  playSoundOverlay, 
  stopSoundOverlay,
  playSoundMain,
  stopSoundMain,
  endSoundMain,
  playSoundMain2,
  stopSoundMain2,
  playSoundBg,
  stopSoundBg,
  pauseSoundMain, 
  resumeSoundMain,
  playSoundAmbient, 
  stopSoundAmbient,
} from '../actions/actions_audio'
import { store } from './../store'
import { getSound } from './../models/soundbank'

const AMBIENT_VOLUME_WHEN_IN_BG = .18
const AMBIENT_VOLUME_WHEN_IN_FRONT = 1

// Mixer tracks (sound layers 1,2,3)
let trackBg = []
let trackMain = []
let trackMain2 = []
let trackOverlay = []
let trackAmbient = []
let trackAmbientVolume = 1
// current view
let currentView = null
let removedView = null
let mainPaused = false
let mainUsrPaused = false
let mainSeek = null
let main2Playing = false
let ambientVolDown = false
/**
 * ############
 * ### INIT ###
 */
 export const initTsawMixer = () => {
  //  subscribe to store change (view change)
  store.subscribe(onStoreChange)
  // add dom event listeners
  document.addEventListener("mouseover", onDocMouseOver, false)
  document.addEventListener("mouseout", onDocMouseOut, false)
}

/**
 * check / update sound state (view based)
 * eg. ajax loaded offcanvas
 */
export const startContainerPlayback = (container) => {
  if (!container) {
    return false
  }
  // bg
  const bgAudio = container.querySelector("*[data-tsaw-audio-bg]")
  const bgPath = bgAudio ? bgAudio.dataset.tsawAudioBg : null
  if (bgPath) {
    // trace("found bgAUDIO:", bgPath, bgAudio)
    playSoundBg(bgPath, getPlaybackParams(bgAudio))
  }
  // main
  const mainAudio = container.querySelector("*[data-tsaw-audio-main]")
  const mainPath = mainAudio ? mainAudio.dataset.tsawAudioMain : null
  if (mainPath) {
    playSoundMain(mainPath, getPlaybackParams(mainAudio))
  }
  // main2
  const main2Audio = container.querySelector("*[data-tsaw-audio-main2]")
  const main2Path = main2Audio ? main2Audio.dataset.tsawAudioMain2 : null
  if (main2Path) {
    playSoundMain2(main2Path, getPlaybackParams(main2Audio))
  }
  // overlay
  const overlayAudio = container.querySelector("*[data-tsaw-audio-overlay]")
  const overlayPath = overlayAudio ? overlayAudio.dataset.tsawAudioOverlay : null
  if (overlayPath) {
    playSoundMain(overlayPath, getPlaybackParams(overlayAudio))
  }
}
export const stopContainerPlayback = (container) => {
  // bg
  const bgAudio = container.querySelector("*[data-tsaw-audio-bg]")
  const bgPath = bgAudio ? bgAudio.dataset.tsawAudioBg : null
  if (bgPath) {
    stopSoundBg(bgPath)
  }
  // main
  const mainAudio = container.querySelector("*[data-tsaw-audio-main]")
  const mainPath = mainAudio ? mainAudio.dataset.tsawAudioMain : null
  if (mainPath) {
    // check sustain param
    stopSoundMain(mainPath)
    // if (mainAudio.dataset.tsawAudioSustain !== "true") {
    //   stopSoundMain(mainPath)
    // }
  }
  // main2
  const main2Audio = container.querySelector("*[data-tsaw-audio-main2]")
  const main2Path = main2Audio ? main2Audio.dataset.tsawAudioMain2 : null
  if (main2Path) {
    stopSoundMain2(main2Path)
  }
  // overlay
  const overlayAudio = container.querySelector("*[data-tsaw-audio-overlay]")
  const overlayPath = overlayAudio ? overlayAudio.dataset.tsawAudioOverlay : null
  if (overlayPath) {
    stopSoundOverlay(overlayPath)
  }
}
// get timecode for track
export const getMainSoundMeta = () => {
  let meta = {}
  if (trackMain.length) {
    const sound = trackMain[0]
    meta = sound.getSoundMeta()
  }
  return meta
}
// skip backward
export const skipMainBackward = () => {
  trackMain.forEach((sound) => {
    sound.skipBackward()
  })
}
// skip forward
export const skipMainForward = () => {
  trackMain.forEach((sound) => {
    sound.skipForward()
  })
}

// get audio playback params from DOM element dataset
const getPlaybackParams = (el) => {
  let params = {}
  if (el.dataset.tsawAudioLoop == "true") {
    params.loop = true
  }
  return params
}


/**
 * Mixer tracks methods
 */
const playOnTrack = (params, track) => {
  // destroy
  let mySound = null
  params = params ? params : {}
  const volume = params?.volume ? params.volume : 1
  const onEnded = params?.onEnded ? params.onEnded : null
  track.forEach((sound, index) => {
    if (sound.path != params.path) {
      sound.stop()
    } else {
      mySound = sound
    }
  })
  if (!mySound) {
    mySound = getSound(params)
    mySound.setVolume(volume)
    mySound.addOnSoundEndedEvent(onEnded)
    mySound.fadeIn(params);
    // trace("play sound", mySound)
  }
  track = [mySound]
  return track
}
const pauseOnTrack = (track, time = 0) => {
  track.forEach((sound, index) => {
    // trace("pause sound", sound)
    sound.fadeOut(time)
  })
}
const resumeOnTrack = (track, rewindSec = 0, params) => {
  const onEnded = params?.onEnded ? params.onEnded : null
  track.forEach((sound, index) => {
    // trace("resume sound", track, sound)
    // check if audio ended?
    const meta = sound.getSoundMeta()
    if (meta.time < meta.duration) {
      sound.skipBackwardSec(rewindSec)
      sound.addOnSoundEndedEvent(onEnded)
      sound.fadeIn({fadeTime: 3})
    }
  })
}
const setVolumeOnTrack = (track, volume) => {
  track.forEach((sound, index) => {
    // trace("set volume", sound, volume, sound.volume)
    sound.setVolume(volume)
  })
}
const seekOnTrack = (track, time) => {
  track.forEach((sound, index) => {
    // trace("seek sound", sound)
    sound.seek(time)
  })
}
const stopOnTrack = (track) => {
  // destroy
  track.forEach((sound, index) => {
    sound.fadeOut(.1, true) // stop
  })
  track = []
  return track
}

/**
 * ######################
 * # DOM Event Handlers #
 * 
*/
// Document mouseover - preload on hover
const onDocMouseOver = (e) => {
  if (e.target?.dataset?.tsawHoverAudio) {
    const path = e.target.dataset.tsawHoverAudio
    const layer = e.target.dataset.tsawHoverLayer ? e.target.dataset.tsawHoverLayer : 'overlay'
    switch (layer) {
      case "main2":
        playSoundMain2(path)
        break;
      default:
        playSoundOverlay(path)
        break;
    }
  }
}
const onDocMouseOut = (e) => {
  if (e.target?.dataset?.tsawHoverAudio) {
    const layer = e.target.dataset.tsawHoverLayer ? e.target.dataset.tsawHoverLayer : 'overlay'
    switch (layer) {
      case "main2":
        stopSoundMain2()
        break;
      default:
        stopSoundOverlay()
        break;
    }
  }
}
const onMainSoundEnd = (sound) => {
  // trace("## on main sound end", sound)
  endSoundMain(sound.path)
}
/**
 * ########################
 * # State event handlers #
 */
const onStoreChange = () => {
  const state = store.getState()
  const boxSoundNav = document.querySelector(".box-sound-nav")
  // #### check all SOUNDS / tracks
  // @ sound_bg
  if (state.reducerAudio.sound_bg) {
    trackBg = playOnTrack({...state.reducerAudio.sound_bg, trackName: 'bg'}, trackBg)
    trace("> play on BG track", state.reducerAudio.sound_bg, trackBg)
  } else {
    trackBg = stopOnTrack(trackBg)
    // trace("|| stop on BG track", state.reducerAudio.sound_bg, trackBg)
  }
  // @ sound_main
  if (state.reducerAudio.sound_main && state.reducerAudio.sound_main.path != state.reducerAudio.sound_main_ended_path) {
    trackMain = playOnTrack({...state.reducerAudio.sound_main, trackName: 'main', onEnded: onMainSoundEnd}, trackMain)
    trace("> play on MAIN track", state.reducerAudio.sound_main, trackMain)
    // @ check pause AUTO
    if (state.reducerAudio.sound_main_paused != mainPaused) {
      mainPaused = state.reducerAudio.sound_main_paused
      if (mainPaused) {
        pauseOnTrack(trackMain, 1)
      } else if (!state.reducerAudio.sound_main_usr_paused) {
        resumeOnTrack(trackMain, 3, {onEnded: onMainSoundEnd})
      }
    }
    // @ check pause by USER
    if (state.reducerAudio.sound_main_usr_paused != mainUsrPaused) {
      mainUsrPaused = state.reducerAudio.sound_main_usr_paused
      if (mainUsrPaused) {
        pauseOnTrack(trackMain)
      } else if (!state.reducerAudio.sound_main_paused) {
        resumeOnTrack(trackMain, 0, {onEnded: onMainSoundEnd})
      }
    }
    // PLAY / PAUSE set box audio class name
    if (!state.reducerAudio.sound_main_paused 
      && !state.reducerAudio.sound_main_usr_paused) {
      // trace("$$$$$$$$$$$")
      // trace("main audio playback")
      // trace("$$$$$$$$$$$")
      boxSoundNav.classList.add("main-audio-playback")
    } else {
      // trace("$$$$$$$$$$$")
      // trace("no audio playback REMOVE CLASS")
      // trace("$$$$$$$$$$$")
      boxSoundNav.classList.remove("main-audio-playback")
    }
    // check seek
    if (state.reducerAudio.sound_main_seek && state.reducerAudio.sound_main_seek != mainSeek) {
      mainSeek = state.reducerAudio.sound_main_seek
      seekOnTrack(trackMain, mainSeek)
    }
  } else {
    trackMain = stopOnTrack(trackMain)
    boxSoundNav.classList.remove("main-audio-playback")
    // trace("|| stop on MAIN track", state.reducerAudio.sound_main, trackMain)
  }
  // @ sound main2
  if (state.reducerAudio.sound_main_2) {
    if (!main2Playing) {
      trackMain2 = playOnTrack({...state.reducerAudio.sound_main_2, trackName: 'main2'}, trackMain2)
      main2Playing = true
      // pause Main
      pauseSoundMain()
    }
  } else {
    if (main2Playing) {
      trackMain2 = stopOnTrack(trackMain2)
      main2Playing = false
      // resume Main
      resumeSoundMain()
    }
  }
  // @ sound overlay
  if (state.reducerAudio.sound_overlay) {
    trackOverlay = playOnTrack({...state.reducerAudio.sound_overlay, trackName: 'overlay'}, trackOverlay)
    // trace("> play on OVERLAY track", state.reducerAudio.sound_overlay, trackOverlay)
  } else {
    trackOverlay = stopOnTrack(trackOverlay)
    // trace("|| stop on OVERLAY track", state.reducerAudio.sound_overlay, trackOverlay)
  }
  // @ sound ambient
  if (state.reducerAudio.sound_ambient) {
    trackAmbient = playOnTrack({...state.reducerAudio.sound_ambient, trackName: 'ambient', volume: trackAmbientVolume}, trackAmbient)
    trace("> play on AMBIENT track", state.reducerAudio.sound_ambient, trackAmbient)
  } else {
    trackAmbient = stopOnTrack(trackAmbient)
  }
  // check sound ambient volume down
  if (state.reducerAudio.sound_ambient_vol_dwn !== ambientVolDown) {
    ambientVolDown = state.reducerAudio.sound_ambient_vol_dwn
    trace("change ambient sound volume", ambientVolDown)
    if (ambientVolDown) {
      setVolumeOnTrack(trackAmbient, AMBIENT_VOLUME_WHEN_IN_BG)
      trackAmbientVolume = AMBIENT_VOLUME_WHEN_IN_BG
    } else {
      setVolumeOnTrack(trackAmbient, AMBIENT_VOLUME_WHEN_IN_FRONT)
      trackAmbientVolume = AMBIENT_VOLUME_WHEN_IN_FRONT
    }
  }
  // #### check VIEW state
  // ## check view remove
  if (state.reducerRouter.removed_view !== removedView) {
    removedView = state.reducerRouter.removed_view
    stopContainerPlayback(state.reducerRouter.removed_container)
  }
  // ## check view append
  if (state.reducerRouter.view !== currentView) {
    currentView = state.reducerRouter.view
    startContainerPlayback(state.reducerRouter.container) 
  }
  
}
